import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

const ProtectedRoute = () => {
	const userInfo = useSelector((state) => state.user);
	if (userInfo === null || userInfo === undefined) {
		window.location.href = "/login";
		return null;
	}

	if (userInfo.callnext == "login/mfa" || userInfo.callnext == "qrcode/pin") {
		window.location.href = "/login-mfa";
		return;
	} else if (userInfo.callnext == "login/qrcode") {
		window.location.href = "/login-qr-code";
		return;
	} else if (userInfo.callnext == "qrcode/setquestion") {
		window.location.href = "/login-set-question";
		return;
	}

	return <Outlet />;
};
export default ProtectedRoute;
